// Primary 2 Mathematics Data - 小學二年級數學數據
export const p2MathsData = {
  title: '小學二年級數學',
  description: '進一步學習數學概念，掌握基本運算技能',
  grade: 'P2',
  year: '小學二年級',
  
  topics: [
    {
      id: 'p2-2n1',
      code: '2N1',
      title: '三位數',
      description: '認識三位數，理解百位、十位、個位',
      objectives: [
        '認識100-999的數字',
        '理解百位、十位、個位的概念',
        '學會讀寫三位數',
        '比較三位數的大小'
      ],
      sampleQuestions: [
        {
          id: 'p2-2n1-q1',
          question: '寫出數字：三百二十五',
          answer: '325',
          solution: '三百二十五 = 300 + 20 + 5 = 325\n三百表示3個百，二十表示2個十，五表示5個一。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n1-q2',
          question: '讀出數字：456',
          answer: '四百五十六',
          solution: '456 = 400 + 50 + 6\n4在百位表示四百，5在十位表示五十，6在個位表示六。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n1-q3',
          question: '比較大小：234 和 243',
          answer: '234 < 243',
          solution: '比較十位：3 < 4，所以234 < 243\n即使百位和個位相同，但十位決定大小。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n1-q4',
          question: '在200到300之間有多少個數字？',
          answer: '99個',
          solution: '200到300之間的數字是：201, 202, ..., 299，共99個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n1-q5',
          question: '寫出比789大1的數字。',
          answer: '790',
          solution: '789 + 1 = 790\n789的個位是9，加1後變成10，進位到十位，所以是790。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2n2',
      code: '2N2',
      title: '加法和減法(二)',
      description: '學習三位數的加減法運算',
      objectives: [
        '學會三位數的加法',
        '學會三位數的減法',
        '理解進位和退位的概念',
        '解決三位數的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2n2-q1',
          question: '計算：234 + 567 = ?',
          answer: '801',
          solution: '234 + 567 = 801\n個位：4 + 7 = 11，寫1進1\n十位：3 + 6 + 1 = 10，寫0進1\n百位：2 + 5 + 1 = 8',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n2-q2',
          question: '計算：456 - 178 = ?',
          answer: '278',
          solution: '456 - 178 = 278\n個位：6 - 8不夠，向十位借1，16 - 8 = 8\n十位：5 - 1 - 7不夠，向百位借1，15 - 7 = 8\n百位：4 - 1 - 1 = 2',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n2-q3',
          question: '小明有345元，買了一本書花了128元，還剩下多少元？',
          answer: '217元',
          solution: '345 - 128 = 217\n小明原本有345元，花了128元，所以還剩下217元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n2-q4',
          question: '計算：234 + 456 + 789 = ?',
          answer: '1479',
          solution: '234 + 456 + 789 = 1479\n先算：234 + 456 = 690\n再算：690 + 789 = 1479',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n2-q5',
          question: '小華有567個糖果，給了小明234個，又給了小紅123個，還剩下多少個？',
          answer: '210個',
          solution: '567 - 234 - 123 = 210\n先算：567 - 234 = 333\n再算：333 - 123 = 210',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2n3',
      code: '2N3',
      title: '基本乘法',
      description: '學習基本的乘法概念和運算',
      objectives: [
        '理解乘法的概念',
        '學會乘法口訣',
        '學會簡單的乘法運算',
        '解決乘法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2n3-q1',
          question: '計算：3 × 4 = ?',
          answer: '12',
          solution: '3 × 4 = 12\n可以用加法：3 + 3 + 3 + 3 = 12\n也可以用乘法口訣：三四十二。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n3-q2',
          question: '計算：7 × 8 = ?',
          answer: '56',
          solution: '7 × 8 = 56\n用乘法口訣：七八五十六。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n3-q3',
          question: '小明有5個盒子，每個盒子有6個蘋果，一共有多少個蘋果？',
          answer: '30個',
          solution: '5 × 6 = 30\n5個盒子，每個盒子6個蘋果，所以一共有30個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n3-q4',
          question: '計算：9 × 7 = ?',
          answer: '63',
          solution: '9 × 7 = 63\n用乘法口訣：九七六十三。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n3-q5',
          question: '小華有8排椅子，每排有9張椅子，一共有多少張椅子？',
          answer: '72張',
          solution: '8 × 9 = 72\n8排椅子，每排9張，所以一共有72張椅子。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2n4',
      code: '2N4',
      title: '四位數',
      description: '認識四位數，理解千位概念',
      objectives: [
        '認識1000-9999的數字',
        '理解千位、百位、十位、個位',
        '學會讀寫四位數',
        '比較四位數的大小'
      ],
      sampleQuestions: [
        {
          id: 'p2-2n4-q1',
          question: '寫出數字：二千三百四十五',
          answer: '2345',
          solution: '二千三百四十五 = 2000 + 300 + 40 + 5 = 2345\n二千表示2個千，三百表示3個百，四十表示4個十，五表示5個一。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n4-q2',
          question: '讀出數字：5678',
          answer: '五千六百七十八',
          solution: '5678 = 5000 + 600 + 70 + 8\n5在千位表示五千，6在百位表示六百，7在十位表示七十，8在個位表示八。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n4-q3',
          question: '比較大小：2345 和 2435',
          answer: '2345 < 2435',
          solution: '比較百位：3 < 4，所以2345 < 2435\n即使千位和十位、個位相同，但百位決定大小。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n4-q4',
          question: '在3000到4000之間有多少個數字？',
          answer: '999個',
          solution: '3000到4000之間的數字是：3001, 3002, ..., 3999，共999個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n4-q5',
          question: '寫出比9999大1的數字。',
          answer: '10000',
          solution: '9999 + 1 = 10000\n9999加1後變成10000，這是一個五位數。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2n5',
      code: '2N5',
      title: '加法和減法(三)',
      description: '學習四位數的加減法運算',
      objectives: [
        '學會四位數的加法',
        '學會四位數的減法',
        '理解多位數的進位和退位',
        '解決四位數的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2n5-q1',
          question: '計算：1234 + 5678 = ?',
          answer: '6912',
          solution: '1234 + 5678 = 6912\n個位：4 + 8 = 12，寫2進1\n十位：3 + 7 + 1 = 11，寫1進1\n百位：2 + 6 + 1 = 9\n千位：1 + 5 = 6',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n5-q2',
          question: '計算：4567 - 2345 = ?',
          answer: '2222',
          solution: '4567 - 2345 = 2222\n個位：7 - 5 = 2\n十位：6 - 4 = 2\n百位：5 - 3 = 2\n千位：4 - 2 = 2',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n5-q3',
          question: '小明有3456元，買了一台電腦花了2345元，還剩下多少元？',
          answer: '1111元',
          solution: '3456 - 2345 = 1111\n小明原本有3456元，花了2345元，所以還剩下1111元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n5-q4',
          question: '計算：1234 + 2345 + 3456 = ?',
          answer: '7035',
          solution: '1234 + 2345 + 3456 = 7035\n先算：1234 + 2345 = 3579\n再算：3579 + 3456 = 7035',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n5-q5',
          question: '小華有5678個糖果，給了小明2345個，又給了小紅1234個，還剩下多少個？',
          answer: '2099個',
          solution: '5678 - 2345 - 1234 = 2099\n先算：5678 - 2345 = 3333\n再算：3333 - 1234 = 2099',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2n6',
      code: '2N6',
      title: '基本除法',
      description: '學習基本的除法概念和運算',
      objectives: [
        '理解除法的概念',
        '學會簡單的除法運算',
        '理解除法和乘法的關係',
        '解決除法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2n6-q1',
          question: '計算：12 ÷ 3 = ?',
          answer: '4',
          solution: '12 ÷ 3 = 4\n可以用乘法驗證：3 × 4 = 12\n也可以用分組法：12個東西分成3組，每組4個。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n6-q2',
          question: '計算：24 ÷ 6 = ?',
          answer: '4',
          solution: '24 ÷ 6 = 4\n可以用乘法驗證：6 × 4 = 24',
          difficulty: 'basic'
        },
        {
          id: 'p2-2n6-q3',
          question: '小明有24個蘋果，要分給6個小朋友，每人分到多少個？',
          answer: '4個',
          solution: '24 ÷ 6 = 4\n24個蘋果分給6個小朋友，每人分到4個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n6-q4',
          question: '計算：35 ÷ 7 = ?',
          answer: '5',
          solution: '35 ÷ 7 = 5\n可以用乘法驗證：7 × 5 = 35',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2n6-q5',
          question: '小華有48個糖果，要裝在8個盒子裡，每個盒子裝多少個？',
          answer: '6個',
          solution: '48 ÷ 8 = 6\n48個糖果裝在8個盒子裡，每個盒子裝6個糖果。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2m1',
      code: '2M1',
      title: '長度和距離(三)',
      description: '進一步學習長度概念和測量',
      objectives: [
        '學會用米(m)和厘米(cm)測量',
        '理解長度的單位換算',
        '學會長度的估算',
        '解決長度相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2m1-q1',
          question: '1米等於多少厘米？',
          answer: '100厘米',
          solution: '1米 = 100厘米\n這是長度的基本換算關係。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2m1-q2',
          question: '2米5厘米等於多少厘米？',
          answer: '205厘米',
          solution: '2米5厘米 = 2 × 100 + 5 = 200 + 5 = 205厘米',
          difficulty: 'basic'
        },
        {
          id: 'p2-2m1-q3',
          question: '小明身高1米25厘米，小華身高1米30厘米，誰比較高？',
          answer: '小華',
          solution: '1米25厘米 = 125厘米\n1米30厘米 = 130厘米\n130 > 125，所以小華比較高。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m1-q4',
          question: '一條繩子長3米50厘米，剪掉1米20厘米，還剩下多少？',
          answer: '2米30厘米',
          solution: '3米50厘米 - 1米20厘米 = 2米30厘米\n3米50厘米 = 350厘米\n1米20厘米 = 120厘米\n350 - 120 = 230厘米 = 2米30厘米',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m1-q5',
          question: '三根木棒分別長1米20厘米、1米35厘米和1米50厘米，最長的和最短的相差多少？',
          answer: '30厘米',
          solution: '最長：1米50厘米 = 150厘米\n最短：1米20厘米 = 120厘米\n150 - 120 = 30厘米',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2m2',
      code: '2M2',
      title: '時間(二)',
      description: '進一步學習時間概念',
      objectives: [
        '學會讀半點時間',
        '理解分鐘的概念',
        '學會時間的加減法',
        '解決時間相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2m2-q1',
          question: '時鐘顯示3點30分，用數字表示是幾點？',
          answer: '3:30',
          solution: '3點30分用數字表示是3:30\n時針指向3和4之間，分針指向6。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2m2-q2',
          question: '上午9點30分到下午2點15分，經過了多少時間？',
          answer: '4小時45分鐘',
          solution: '上午9點30分到下午2點15分\n9點30分到12點：2小時30分鐘\n12點到2點15分：2小時15分鐘\n2小時30分鐘 + 2小時15分鐘 = 4小時45分鐘',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m2-q3',
          question: '小明早上7點30分起床，晚上9點15分睡覺，他一天醒著多少時間？',
          answer: '13小時45分鐘',
          solution: '早上7點30分到晚上9點15分\n7點30分到12點：4小時30分鐘\n12點到9點15分：9小時15分鐘\n4小時30分鐘 + 9小時15分鐘 = 13小時45分鐘',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m2-q4',
          question: '小華下午2點開始做功課，做了1小時30分鐘，幾點做完？',
          answer: '下午3點30分',
          solution: '下午2點 + 1小時30分鐘 = 下午3點30分',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m2-q5',
          question: '上午10點15分到下午4點45分，中間經過了多少時間？',
          answer: '6小時30分鐘',
          solution: '上午10點15分到下午4點45分\n10點15分到12點：1小時45分鐘\n12點到4點45分：4小時45分鐘\n1小時45分鐘 + 4小時45分鐘 = 6小時30分鐘',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2m3',
      code: '2M3',
      title: '貨幣(二)',
      description: '進一步學習貨幣概念和計算',
      objectives: [
        '學會複雜的貨幣計算',
        '理解找零的概念',
        '學會貨幣的估算',
        '解決購物相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p2-2m3-q1',
          question: '小明有10元，買了一本書花了6元5角，還剩下多少錢？',
          answer: '3元5角',
          solution: '10元 - 6元5角 = 3元5角\n10元 = 100角，6元5角 = 65角\n100 - 65 = 35角 = 3元5角',
          difficulty: 'basic'
        },
        {
          id: 'p2-2m3-q2',
          question: '一包糖果賣2元8角，小明買了3包，一共要付多少錢？',
          answer: '8元4角',
          solution: '2元8角 × 3 = 8元4角\n2元8角 = 28角\n28 × 3 = 84角 = 8元4角',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m3-q3',
          question: '小華有15元，買了一本書花了8元2角，又買了一支筆花了3元5角，還剩下多少錢？',
          answer: '3元3角',
          solution: '15元 - 8元2角 - 3元5角 = 3元3角\n先算：15元 - 8元2角 = 6元8角\n再算：6元8角 - 3元5角 = 3元3角',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m3-q4',
          question: '一盒餅乾賣5元，小明有20元，最多可以買幾盒？',
          answer: '4盒',
          solution: '20 ÷ 5 = 4\n20元可以買4盒餅乾，每盒5元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2m3-q5',
          question: '小華有25元，買了3包糖果，每包8元，還剩下多少錢？',
          answer: '1元',
          solution: '3包糖果：8元 × 3 = 24元\n25元 - 24元 = 1元\n所以還剩下1元。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2s1',
      code: '2S1',
      title: '立體圖形(二)',
      description: '進一步認識立體圖形',
      objectives: [
        '認識更多種類的立體圖形',
        '學會比較立體圖形的特徵',
        '理解立體圖形的基本性質',
        '學會立體圖形的分類'
      ],
      sampleQuestions: [
        {
          id: 'p2-2s1-q1',
          question: '一個圓柱體有多少個面？',
          answer: '3個面',
          solution: '圓柱體有3個面：2個圓形底面和1個曲面。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s1-q2',
          question: '一個圓錐體有多少個頂點？',
          answer: '1個頂點',
          solution: '圓錐體有1個頂點，1個圓形底面，1個曲面。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s1-q3',
          question: '正方體和長方體有什麼相同點？',
          answer: '都有6個面',
          solution: '正方體和長方體都有6個面，都是四邊形，都有8個頂點。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s1-q4',
          question: '圓柱體和圓錐體有什麼不同？',
          answer: '頂點數量不同',
          solution: '圓柱體沒有頂點，圓錐體有1個頂點。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s1-q5',
          question: '一個球體有多少個面？',
          answer: '1個面',
          solution: '球體只有1個曲面，沒有平面。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2s2',
      code: '2S2',
      title: '角',
      description: '認識角的基本概念',
      objectives: [
        '認識角的概念',
        '學會比較角的大小',
        '理解直角的概念',
        '學會簡單的角的分類'
      ],
      sampleQuestions: [
        {
          id: 'p2-2s2-q1',
          question: '一個角有多少條邊？',
          answer: '2條邊',
          solution: '一個角由2條射線組成，這2條射線叫做角的邊。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s2-q2',
          question: '直角是多少度？',
          answer: '90度',
          solution: '直角是90度，可以用直角尺來測量。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s2-q3',
          question: '比直角小的角叫什麼？',
          answer: '銳角',
          solution: '比直角小的角叫銳角，小於90度。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s2-q4',
          question: '比直角大的角叫什麼？',
          answer: '鈍角',
          solution: '比直角大的角叫鈍角，大於90度。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s2-q5',
          question: '正方形的四個角都是什麼角？',
          answer: '直角',
          solution: '正方形的四個角都是直角，每個角都是90度。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2s3',
      code: '2S3',
      title: '方向和位置(二)',
      description: '進一步學習方向概念',
      objectives: [
        '認識東南西北四個方向',
        '學會使用方向指示',
        '理解相對位置的概念',
        '學會簡單的地圖閱讀'
      ],
      sampleQuestions: [
        {
          id: 'p2-2s3-q1',
          question: '面向北方，右邊是什麼方向？',
          answer: '東方',
          solution: '面向北方時，右邊是東方。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s3-q2',
          question: '面向西方，後面是什麼方向？',
          answer: '東方',
          solution: '面向西方時，後面是東方。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s3-q3',
          question: '小明在小華的東邊，小華在小明的什麼方向？',
          answer: '西邊',
          solution: '如果小明在小華的東邊，那麼小華就在小明的西邊。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s3-q4',
          question: '學校在家的北邊，家在學校的什麼方向？',
          answer: '南邊',
          solution: '如果學校在家的北邊，那麼家就在學校的南邊。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s3-q5',
          question: '面向南方，左邊是什麼方向？',
          answer: '東方',
          solution: '面向南方時，左邊是東方。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2s4',
      code: '2S4',
      title: '四邊形(一)',
      description: '認識四邊形的基本概念',
      objectives: [
        '認識四邊形的概念',
        '學會識別不同種類的四邊形',
        '理解四邊形的基本性質',
        '學會四邊形的分類'
      ],
      sampleQuestions: [
        {
          id: 'p2-2s4-q1',
          question: '四邊形有多少條邊？',
          answer: '4條邊',
          solution: '四邊形有4條邊，4個角。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s4-q2',
          question: '正方形的四條邊有什麼特點？',
          answer: '都相等',
          solution: '正方形的四條邊都相等，四個角都是直角。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2s4-q3',
          question: '長方形的對邊有什麼特點？',
          answer: '相等',
          solution: '長方形的對邊相等，四個角都是直角。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s4-q4',
          question: '正方形和長方形有什麼相同點？',
          answer: '都有4個直角',
          solution: '正方形和長方形都有4個直角，都是四邊形。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2s4-q5',
          question: '平行四邊形的對邊有什麼特點？',
          answer: '平行且相等',
          solution: '平行四邊形的對邊平行且相等。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2d1',
      code: '2D1',
      title: '象形圖',
      description: '認識象形圖的基本概念',
      objectives: [
        '認識象形圖的概念',
        '學會讀取象形圖的數據',
        '理解象形圖的用途',
        '學會簡單的數據分析'
      ],
      sampleQuestions: [
        {
          id: 'p2-2d1-q1',
          question: '象形圖中，一個圖案代表多少個？',
          answer: '需要看圖例',
          solution: '要根據象形圖的圖例來確定每個圖案代表多少個。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2d1-q2',
          question: '如果一個蘋果圖案代表5個蘋果，3個蘋果圖案代表多少個蘋果？',
          answer: '15個',
          solution: '3 × 5 = 15\n3個蘋果圖案代表15個蘋果。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2d1-q3',
          question: '小明有20個蘋果，用象形圖表示，每個圖案代表5個，需要畫幾個圖案？',
          answer: '4個',
          solution: '20 ÷ 5 = 4\n需要畫4個蘋果圖案。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2d1-q4',
          question: '小華有12個糖果，小紅有8個糖果，用象形圖表示，每個圖案代表2個，各需要畫幾個圖案？',
          answer: '小華6個，小紅4個',
          solution: '小華：12 ÷ 2 = 6個圖案\n小紅：8 ÷ 2 = 4個圖案',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2d1-q5',
          question: '三個班級分別有15、20、25個學生，用象形圖表示，每個圖案代表5個學生，各需要畫幾個圖案？',
          answer: '3個、4個、5個',
          solution: '第一班：15 ÷ 5 = 3個圖案\n第二班：20 ÷ 5 = 4個圖案\n第三班：25 ÷ 5 = 5個圖案',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p2-2f1',
      code: '2F1',
      title: '探索與研究',
      description: '通過活動發現數學規律',
      objectives: [
        '培養數學思維能力',
        '學會觀察和發現規律',
        '提高解決問題的能力',
        '培養探索精神'
      ],
      sampleQuestions: [
        {
          id: 'p2-2f1-q1',
          question: '觀察數字：3, 6, 9, 12, 15，下一個數字是什麼？',
          answer: '18',
          solution: '每個數字都比前一個多3，所以下一個是15 + 3 = 18。',
          difficulty: 'basic'
        },
        {
          id: 'p2-2f1-q2',
          question: '用4個相同的正方形可以拼成什麼圖形？',
          answer: '正方形或長方形',
          solution: '4個正方形可以拼成一個大正方形，也可以拼成長方形。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2f1-q3',
          question: '小明有8個蘋果，每次吃2個，可以吃幾天？',
          answer: '4天',
          solution: '8 ÷ 2 = 4\n8個蘋果，每天吃2個，可以吃4天。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2f1-q4',
          question: '找出規律：2, 4, 8, 16, ?',
          answer: '32',
          solution: '每個數字都是前一個的2倍，所以下一個是16 × 2 = 32。',
          difficulty: 'intermediate'
        },
        {
          id: 'p2-2f1-q5',
          question: '用6根相同長度的木棒可以拼成什麼圖形？',
          answer: '正六邊形',
          solution: '6根相同長度的木棒可以拼成正六邊形。',
          difficulty: 'advanced'
        }
      ]
    }
  ]
}; 